let getRandomValues = require("./random");

module.exports = function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$syllablesCount = _ref.syllablesCount,
      syllablesCount = _ref$syllablesCount === void 0 ? 3 : _ref$syllablesCount,
      _ref$minSyllableLengt = _ref.minSyllableLength,
      minSyllableLength = _ref$minSyllableLengt === void 0 ? 2 : _ref$minSyllableLengt,
      _ref$maxSyllableLengt = _ref.maxSyllableLength,
      maxSyllableLength = _ref$maxSyllableLengt === void 0 ? 3 : _ref$maxSyllableLengt,
      _ref$hasNumbers = _ref.hasNumbers,
      hasNumbers = _ref$hasNumbers === void 0 ? true : _ref$hasNumbers,
      _ref$titlecased = _ref.titlecased,
      titlecased = _ref$titlecased === void 0 ? true : _ref$titlecased,
      _ref$separators = _ref.separators,
      separators = _ref$separators === void 0 ? "" : _ref$separators,
      _ref$vowels = _ref.vowels,
      vowels = _ref$vowels === void 0 ? "aeiouy" : _ref$vowels,
      _ref$consonants = _ref.consonants,
      consonants = _ref$consonants === void 0 ? "bcdfghjklmnpqrstvwxz" : _ref$consonants;

  return produce(syllablesCount, i => {
    let length = minSyllableLength + random(maxSyllableLength - minSyllableLength + 1);
    let syllable = produce(length, index => {
      let alpha = index % 2 ? vowels : consonants;
      let char = alpha[random(alpha.length)];
      return titlecased && !index ? char.toUpperCase() : char;
    });
    if (hasNumbers) syllable += random(10);
    return i && separators ? separators[random(separators.length)] + syllable : syllable;
  });
};

let produce = (number, callback) => {
  for (var i = 0, result = ""; i < number; i++) result += callback(i);

  return result;
};

let buffer = [];
let bufferSize = 0xffff;
let bufferIndex = bufferSize;

let random = limit => {
  if (bufferIndex >= bufferSize) {
    buffer = getRandomValues(bufferSize);
    bufferIndex = 0;
  }

  return buffer[bufferIndex++] % limit;
};